<template>
  <h1>
    Together with you, we support <br />the project
    <span style="color: #92a2ff">Natur Stiften</span>...
  </h1>
</template>

<script>
export default {
  mounted() {
    setTimeout(() => {
      this.$emit("next");
    }, 3100);
  },
};
</script>
